import { ref } from 'vue';
import { fetchComplaints } from '@/api/complaintsApi';

const openCount = ref(0);
const loadFailed = ref(false);

let inflightPromise = null;
let pendingInvalidation = false;
let generation = 0;

async function fetchOpenCount(seq) {
  try {
    const [received, inReview] = await Promise.all([
      fetchComplaints({ status: 'new', page: 1, page_size: 10 }),
      fetchComplaints({ status: 'in_review', page: 1, page_size: 10 })
    ]);
    if (seq !== generation) return;
    openCount.value = Math.max(0, Number(received?.total || 0))
      + Math.max(0, Number(inReview?.total || 0));
    loadFailed.value = false;
  } catch (error) {
    if (seq !== generation) return;
    loadFailed.value = true;
    console.warn('Failed to load complaints summary:', error);
  }
}

function runRefresh() {
  const seq = generation;
  const promise = (async () => {
    do {
      pendingInvalidation = false;
      await fetchOpenCount(seq);
    } while (seq === generation && pendingInvalidation);
  })().finally(() => {
    if (inflightPromise === promise) inflightPromise = null;
  });
  inflightPromise = promise;
  return promise;
}

/** Shared open-complaint count for the review queue and sidebar badge. */
export function useComplaintsSummary() {
  function refresh() {
    return inflightPromise || runRefresh();
  }

  function invalidate() {
    if (inflightPromise) pendingInvalidation = true;
    else void refresh();
  }

  function reset() {
    generation += 1;
    inflightPromise = null;
    pendingInvalidation = false;
    openCount.value = 0;
    loadFailed.value = false;
  }

  return {
    openCount,
    loadFailed,
    refresh,
    invalidate,
    reset
  };
}
